import { useCallback } from 'react';

import { TargetModel } from '../../../../modules/Apps';
import { useDeleteTarget } from '../../../../modules/Apps/Targets';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface DisableTargetDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  target: TargetModel;
}

export function DeleteTargetDialog({ isOpen, handleClose, target }: DisableTargetDialogProps) {
  const { mutateAsync, isPending } = useDeleteTarget();
  const toaster = useToastNotification();

  const disableTarget = useCallback(async () => {
    try {
      const { appId, targetId } = target;
      await mutateAsync({ appId, targetId });
      toaster.showSuccess('Target was successfully deleted!');
      handleClose();
    } catch (error) {
      toaster.showError('There was an error deleting the target. Please, try again later.');
    }
  }, [mutateAsync, target, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Delete"
      heading="Delete Target"
      text={`Are you sure you want to delete ${target.name} Target?`}
      handleConfirm={disableTarget}
      handleDismiss={handleClose}
      destructive
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
